import styled from 'styled-components';

export const Wrapper = styled.div.attrs(() => ({
    className: String('ap-radioGroup-wrapper')
}))`
    display: inline-block;
    width: auto;
    height: auto;
`;
